import React, { useCallback } from "react";
import { Input } from "../../style/Input";
import { LoginLabel } from "../../style/Label";
import { LoginHeading, } from "../../style/Login";
import { CustomDiv } from "../../style/shared";
import { Button } from "../../style/Button";
import { useHistory } from 'react-router-dom';
import { Logo1 } from "../logo/Logo";
import { isAdmin, verifyAuth } from "../../authverify";
import { serverUrl, EMAIL_IS_IN_USE, USER_REGISTERED_SUCCESS} from "../../appconst";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import "./signup.css";
export class CreateUser extends React.Component {

  constructor(props) {
    super(props);

    var data = JSON.parse(window.sessionStorage.getItem("usersession"))

     if (data == null || !verifyAuth() || data.role !== "Admin") {
       this.props.history.push({
         pathname: '/',
       });
     }

    this.state = {
      uname: "",
      password: "",
      designation: "",
      email: "",
      company: "",
      country: ""
    }
  }

  manageUser = () => {
    this.props.history.push({
      pathname: '/UserManagement',
    });
  }

  handleOnClick = () => {

    fetch(`${serverUrl}/api/auth/createuser`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "fullname": this.state.uname,
        "email": this.state.email,
        "password": this.state.password,
        "designation": this.state.designation,
        "country": this.state.country,
        "company": this.state.company,
        "role": "DemoUser"
         })
    })
    .then(res => res.json())
    .then((data) => {
        if (data.message === EMAIL_IS_IN_USE) {
        alert(data.message)
      }
        else if (data.message === USER_REGISTERED_SUCCESS) {
        this.state.uname = "";
        this.state.password = "";
        this.state.designation = "";
        this.state.email = "";
        this.state.company = "";
        this.state.country = "";
        alert(data.message);
        this.forceUpdate();
        // this.props.history.push({
        //   pathname: "/",
        // });
        } else {
        alert("Error creating user");
       }
    })
    .catch(console.log);

  };
  render() {
  return (
    <>
        <Grid container spacing={24}
          justifyContent="center"
          alignContent="center"
          style={{ maxWidth: '100%', position: "absolute", zIndex: -10 }}>
         
        </Grid>
        <Container style={{ zIndex: "900" }}>
          <Grid container spacing={24}
            justifyContent="center"
            alignContent="center"
            >
            
            <Grid item xs={6} style={{
              marginTop: "50%",
              transform: "translate(0%,-85%)"
            }}>
              <Container>
              <div><button onClick={this.manageUser}>ManageUser</button></div>
              <LoginHeading>Create User</LoginHeading>
              <CustomDiv marginT="10px">

              <LoginLabel
                  display="block"
                  color="#969696"
                  margin="10px 0px 10px 18%"
                >
                  Name*{" "}
                </LoginLabel>
                <Input value={this.state.uname }
                  height="35px"
                  width="356px"
                  margin="10px 0px 0px 18%"
                    name="uname" onChange={(event) => this.setState({ uname: event.target.value })}
                  placeholder=""
                />

                  <LoginLabel
                  display="block"
                  color="#969696"
                  margin="10px 0px 10px 18%"
                >
                   Designation*{" "}
                </LoginLabel>
                <Input value={this.state.designation }
                  height="35px"
                  width="356px"
                  margin="10px 0px 0px 18%"
                    name="designation" onChange={(event) => this.setState({ designation: event.target.value })}
                  placeholder=""
                />

                  <LoginLabel
                  display="block"
                  color="#969696"
                  margin="10px 0px 10px 18%"
                >
                            Email*{" "}
                </LoginLabel>
                <Input value={this.state.email }
                  height="35px"
                  width="356px"
                  margin="10px 0px 0px 18%"
                    name="email" onChange={(event) => this.setState({ email: event.target.value })}
                  placeholder=""
                />

                <LoginLabel
                  display="block"
                  color="#969696"
                  margin="10px 0px 10px 18%"
                >
                            Password*{" "}
                </LoginLabel>
                <Input type="password" value={this.state.password }
                  height="35px"
                  width="356px"
                  margin="10px 0px 0px 18%"
                    name="password" onChange={(event) => this.setState({ password: event.target.value })}
                  placeholder=""
                />
                  <LoginLabel
                  display="block"
                  color="#969696"
                  margin="10px 0px 10px 18%"
                >
                            Company*{" "}
                </LoginLabel>
                <Input value={this.state.company }
                  height="35px"
                  width="356px"
                  margin="10px 0px 0px 18%"
                    name="company" onChange={(event) => this.setState({ company: event.target.value })}
                  placeholder=""
                />
                  <LoginLabel
                  display="block"
                  color="#969696"
                  margin="10px 0px 10px 18%"
                >
                            Country*{" "}
                </LoginLabel>
                <Input value={this.state.country }
                  height="35px"
                  width="356px"
                  margin="10px 0px 0px 18%"
                    name="country" onChange={(event) => this.setState({ country: event.target.value })}
                  placeholder=""
                />
                                <Button
                  width="356px"
                  marginTop="40px"
                  height="45px"
                  marginL="18%"
                    backgroundImage="linear-gradient(to right,#A45BE4 0%, #6B42F6 70%)"
                  style={{ fontWeight: 600, fontSize: "13.8px" }}
                  onClick={this.handleOnClick}
                >
                  Create User
                </Button>
                <LoginLabel
                  display="block"
                  color="#969696"
                  margin="20px 0px 10px 18%"
                    onClick={() => this.props.history.push({
          pathname: "/",
        })}
                >
                    
                </LoginLabel>
      </CustomDiv>
              </Container>
          </Grid>
        </Grid>
        </Container>
    </>
  );
  }
}
